export const rules = {
  firstName: (value) => {
    if (!value || !value.trim()) return 'First name is required';
    if (value.trim().length < 2) return 'First name must be at least 2 characters';
    return null;
  },

  lastName: (value) => {
    if (!value || !value.trim()) return 'Last name is required';
    if (value.trim().length < 2) return 'Last name must be at least 2 characters';
    return null;
  },

  email: (value) => {
    if (!value) return 'Email is required';
    if (!/\S+@\S+\.\S+/.test(value)) return 'Email is invalid';
    return null;
  },

  phone: (value) => {
    if (!value) return 'Phone number is required';
    if (!/^\d+$/.test(value)) return 'Phone number must contain digits only';
    if (!/^0\d{9}$/.test(value)) return 'Phone number must be 10 digits and start with 0';
    return null;
  },

  password: (value) => {
    if (!value) return 'Password is required';
    if (value.length < 8) return 'Password must be at least 8 characters';
    return null;
  },

  passwordConfirmation: (value, password) => {
    if (!value) return 'Please confirm your password';
    if (value !== password) return 'Passwords do not match';
    return null;
  },

  dob: (value, { minAge = 18, maxAge = 80 } = {}) => {
    if (!value) return 'Date of birth is required';

    const dob = new Date(value);
    const today = new Date();

    const age = today.getFullYear() - dob.getFullYear();
    const hasBirthdayPassed =
      today.getMonth() > dob.getMonth() ||
      (today.getMonth() === dob.getMonth() && today.getDate() >= dob.getDate());

    const exactAge = hasBirthdayPassed ? age : age - 1;

    if (exactAge < minAge) return `Must be at least ${minAge} years old`;
    if (exactAge > maxAge) return `Age cannot exceed ${maxAge} years`;

    return null;
  },
};
